import { render, staticRenderFns } from "./StatisticsProgramPeriod.vue?vue&type=template&id=89de4e88&"
import script from "./StatisticsProgramPeriod.vue?vue&type=script&lang=js&"
export * from "./StatisticsProgramPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports